/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateMachineLimitRuleRequestDTO { 
    thresholdValue?: number | null;
    hysteresis?: number | null;
    operator?: CreateMachineLimitRuleRequestDTO.OperatorEnum;
    appScope?: string;
    machineState?: CreateMachineLimitRuleRequestDTO.MachineStateEnum | null;
    enabled?: boolean;
}
export namespace CreateMachineLimitRuleRequestDTO {
    export const OperatorEnum = {
        Lt: 'lt',
        Gt: 'gt'
    } as const;
    export type OperatorEnum = typeof OperatorEnum[keyof typeof OperatorEnum];
    export const MachineStateEnum = {
        Standby: 'standby',
        Startup: 'startup',
        SlowingDown: 'slowing_down',
        Production: 'production',
        Cip: 'cip',
        TotalEjection: 'total_ejection',
        PartialEjection: 'partial_ejection',
        Standstill: 'standstill',
        ClosingProgram: 'closing_program',
        Overflow: 'overflow'
    } as const;
    export type MachineStateEnum = typeof MachineStateEnum[keyof typeof MachineStateEnum];
}


